// src/components/App.jsx
import React from "react";
import { Route, Switch } from "react-router-dom";
import { AuthRoute /*, ProtectedRoute */ } from "../util/route_util";

import Navbar from "./navbar/navbar";
import MainPage from "./main/main_page";

import AboutMe from "./main/aboutme";
import Work from "./main/commercialwork";

import Paintings from "./main/paintings_container";
import Painting from "./main/painting_container";

import Photographs from "./main/photographs_container";
import Photograph from "./main/photograph_container";

import Prints from "./main/prints_container";
import Print from "./main/print_container";

import Humanitarian from "./main/Humanitarianism";
import childlabor_container from "./main/childlabor_container";
import causes_container from "./main/causes_container";

import WorldRated_container from "./main/WorldRated_container";
import gallery_container from "./main/gallery_container";
// App.jsx (ensure this comes BEFORE your catch-all continent/country route)



import "./App.css";
import FashionPortfolio_container from "./main/fashionPortfolio_container";
import landscapes_container from "./main/landscapes_container";
import WhiteContinent_container from "./main/WhiteContinent_container";


const App = () => (
  <div className="main">
    <Navbar />

    <Switch>
      {/* Home */}
      <AuthRoute exact path="/" component={MainPage} />

      {/* Fixed, named pages FIRST */}
      <AuthRoute exact path="/aboutme" component={AboutMe} />
      <AuthRoute exact path="/commercial" component={Work} />
      <AuthRoute exact path="/world-rated" component={WorldRated_container} />

      {/* Shop / Prints / Paintings */}
      <AuthRoute exact path="/shop/paintings" component={Paintings} />
      
      <AuthRoute exact path="/paintings/:id" component={Painting} />
      <AuthRoute exact path="/shop/portraits" component={Photographs} />
      <AuthRoute exact path="/shop/wildlife" component={landscapes_container} />
            <AuthRoute exact path="/shop/white-continent" component={WhiteContinent_container} />
                        <AuthRoute exact path="/shop/unspoken-journeys" component={WhiteContinent_container} />
                        <AuthRoute exact path="/shop/silent-vessels" component={WhiteContinent_container} />
          <AuthRoute exact path="/shop/fading" component={WhiteContinent_container} />
      {/* Prints */}
      <AuthRoute exact path="/prints" component={Prints} />
      <AuthRoute exact path="/prints/:id" component={Print} />

      {/* Humanitarianism */}
 <AuthRoute exact path="/humanitarianism" component={Humanitarian} />
      <AuthRoute exact path="/humanitarianism/child-labor" component={childlabor_container} />
      <AuthRoute exact path="/humanitarianism/causes" component={causes_container} />

       {/* Fashion */}
      <AuthRoute exact path="/fashion" component={FashionPortfolio_container} />

      {/* Photos */}
      <AuthRoute exact path="/photographs/:id" component={Photograph} />

      {/* Gallery catch-all ONLY for valid continents */}
      <AuthRoute
        path="/:continent(africa|asia|southamerica|northamerica|europe|antarctica|australia)/:country?"
        component={gallery_container}
      />
      

      {/* Optional: 404 fallback */}
      {/* <Route component={NotFound} /> */}
    </Switch>
  </div>
);

export default App;
